import React, { useState, useEffect, useRef }  from 'react';
import { MyDownloadsButton } from 'components/show_drawing/download_buttons/index.js';
import { ContentPopup } from 'components/ContentPopup.jsx';
import ConfirmEmailWithCode from 'components/ConfirmEmailWithCode.jsx';

const NeedsToConfirmEmail = ({ onSuccess }) => {
  const handleClick = (e) => {
    e.preventDefault()
    setShowPopUp( () => true );
  }

  const [showPopUp, setShowPopUp] = useState(false);
  const popupRef = useRef();

  const handleBackClick = (e) => {
    e.preventDefault();
  }

  const [subscription, setSubscription] = useState({})
  const [currencyName, setCurrencyName] = useState('')

  useEffect(() => {
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('layouts.download_buttons_ready', {}));
    }, 250);
  }, []);

  const popupContent = () => {
    let callback = () => {
      popupRef.current.style.display = "none";
      setShowPopUp(() => false);
    };

    const handleConfirmed = () => {
      callback()
      onSuccess();
    }

    return <ContentPopup
      contextClass="wrapper"
      myRef={popupRef}
      autoOpen={true}
      content={<ConfirmEmailWithCode onConfirmed={handleConfirmed} />}
      cancelButton={false}
      beforeClose={callback}
      notWide={true}
      modalStyle={{ width: '460px', minWidth: '0', maxWidth: '92vw' }}
    />;
  }
  return (
    <div className="downloadButtonscontainer">

      <div className="inner">
        <div className="child"> <br />
          <button className={`btn btn-default btn-lg download-btn confirm-btn-with-icons-${window.I18nLocale}`} onClick={handleClick} style={{"width": "540px"}}>
            <img src={window.dxf_svg_and_pdf_icon} className="downloadIcons" /> {t('nav.confirmation')}
          </button>
        </div>
      </div>

      <MyDownloadsButton />

      {showPopUp &&  popupContent()}
    </div>
  )
}

export default NeedsToConfirmEmail;
